import * as React from 'react'
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { enqueueSnackbar } from "notistack"
import { Typography, Paper, Box, Button, CardContent, FormControl, Input, alpha, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { contractorsApi, defaultApi, documentApi } from '../../../api-interface';
import { TenantContext } from '../../..';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { Contractor, ContractorId } from '../../../api';

export async function loader(tenant_id) {
  const user = await defaultApi.readUsersMeMeGet();
  // Extract contractor feature flag
  const useContractor = user.data.tenants.find((x) => x.id === tenant_id)?.feature_flag_contractors || false;
  const ret = {"contractor_flag": useContractor};
  return ret;
}


const AnalyseFile = ({closeModal} : {closeModal: () => void}) => {
    const [files, setFiles] = useState<File[]>()
    const loaded_data = useLoaderData();
    const contractor_flag = loaded_data["contractor_flag"] as boolean;

    const [loading, setLoading] = useState(false)
    const buttonInner = loading ? <CircularProgress size="20px" color="secondary" variant="indeterminate"></CircularProgress> : <>Upload</>

    const theme = useTheme();
    const submit = () => { }
    const onFileInputChange = (e) => {
        setFiles(
            e.target.files
        )
    }
    const onFileDrop = (e) => {
        e.preventDefault()
        const files = e.dataTransfer.files
        if (!files) {
            return
        }
        setFiles(files)
    }
    const selectFile = () => {
        document.getElementById("fileInput")?.click()
    }
    const currentTenant = React.useContext(TenantContext)
    const [contractor, setContractor] = useState<string | null>(null)
    // Get a list of contractors from the API to pick from. This will need to be done when the component loads up (useEffect)
    
    const [contractors, setContractors] = useState<Contractor[]>([])
    useEffect(() => {
        const fetchContractors = async () => {
            const contractors = await contractorsApi(currentTenant).getContractorsContractorsGet()
            setContractors(contractors.data)
        }
        fetchContractors()

    }, [])

    const navigate = useNavigate()
    const uploadFile = async (e) => {
        setLoading(true)
        e.preventDefault()
        try{
            await documentApi(currentTenant).analyzePdfDocumentAnalyzePost(Array.from(files!), {contractor_id: contractor || null})
            setLoading(false)
            enqueueSnackbar("Analysis Uploaded", { variant: "success" })
            navigate("/dashboard/" + currentTenant + "/inspections")
            closeModal()
        } catch (e) {
            const detail = e?.response?.data?.detail
            if (detail === undefined){
                enqueueSnackbar("Error: " + e, { variant: "error" })
            } else {
                enqueueSnackbar("Error: " + detail, { variant: "error" })
            }
            setLoading(false)
            console.error(e)
            closeModal()
        }
        
        


    }

    const should_enable_upload = () => {
        if (!files || files.length === 0) {
            return false
        }
        if (contractor_flag && contractor == null) {
            return false
        }
        return true
    }
    const disabled = !should_enable_upload()
    return (
                <Box>
                    <Paper sx={{borderRadius:4}} elevation={6}>
                        <CardContent>
                            <form onSubmit={submit}>
                                <FormControl fullWidth>
                                    <Input onChange={onFileInputChange} inputProps={{ accept: "application/pdf", multiple: true }} id="fileInput" sx={{ display: "none" }} name="file" type="file"></Input>
                                    <Box onDragOver={(e) => { e.preventDefault() }} onDrop={onFileDrop} bgcolor={alpha(theme.palette.primary.main, 0.10)} textAlign="center" component="section" sx={{ p: 2, border: '1px dashed grey', borderRadius: 4}}>
                                        <Box sx={{ paddingLeft: "30px", paddingRight: "30px"}}>
                                            <FileUploadIcon fontSize="large"></FileUploadIcon>
                                            <Typography fontSize="medium">Drag and drop files here</Typography>
                                            <Typography fontSize="medium">or</Typography>
                                            <Button variant="outlined" onClick={selectFile}>Browse Files</Button>
                                        </Box>
                                        {files && Array.from(files).map( (file, index) => {
                                            return <Typography key={index} fontSize="small">{file.name}</Typography>
                                        })}
                                    </Box>

                                </FormControl>
                                    <Box mt={2} textAlign={'right'}>
                                    {/* Contractor selector */}
                                    {contractor_flag && <FormControl sx={{marginRight: 2}}>
                                        <select onChange={(e) => setContractor(e.target.value)} name="contractor" id="contractor" style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minWidth: "200px"}}>
                                            <option value="" disabled selected>Select Contractor</option>
                                            {contractors.map((contractor) => (
                                                <option key={contractor.id} value={contractor.id}>{contractor.name}</option>
                                            ))}
                                        </select>
                                    </FormControl>}
                                    <Button onClick={uploadFile} disabled={disabled} variant="contained" type="submit">
                                        {buttonInner}
                                    </Button>
                                </Box>
                            </form>
                        </CardContent>
                    </Paper>
                </Box>
    )
}

export default AnalyseFile